import { render, staticRenderFns } from "./_promptDetailPurchaseTypes.vue?vue&type=template&id=4830dd4e&"
import script from "./_promptDetailPurchaseTypes.vue?vue&type=script&lang=js&"
export * from "./_promptDetailPurchaseTypes.vue?vue&type=script&lang=js&"
import style0 from "./_promptDetailPurchaseTypes.vue?vue&type=style&index=0&id=4830dd4e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports